import { OnDestroy, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiFolderTreeModalComponent } from '@components/ui-folder-tree-modal/ui-folder-tree-modal.component';
import { FolderTreeStateService } from '@components/ui-folder-tree/ui-folder-tree-state';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services';
import { combineLatest, of, Subject, } from 'rxjs';
import { filter, map, switchMap, takeUntil, } from 'rxjs/operators';
var UiFolderPickerComponent = /** @class */ (function () {
    function UiFolderPickerComponent(_modalService, _appState, _folderTreeState, _translateService) {
        var _this = this;
        this._modalService = _modalService;
        this._appState = _appState;
        this._folderTreeState = _folderTreeState;
        this._translateService = _translateService;
        this.currentFolderName$ = this._appState.user.folder.value$.pipe(switchMap(function (folder) { return !_this._appState.user.folder.hasAny
            ? _this._translateService.stream('folder_picker_no_folder')
            : of(folder.displayName); }));
        this.currentFolderType$ = combineLatest([
            this._appState.user.folder.type$,
            this._appState.language.value$,
        ])
            .pipe(map(function (_a) {
            var type = _a[0];
            return !type ? null : _this._translateService.instant("folder_picker_tooltip_" + type);
        }));
        this._destroyed$ = new Subject();
        this._appState.user.value$.pipe(filter(function (u) { return !u && !!_this._foldersModal; }), takeUntil(this._destroyed$)).subscribe(function () { return _this._foldersModal.close(); });
    }
    UiFolderPickerComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UiFolderPickerComponent.prototype.openFoldersModal = function () {
        var _this = this;
        if (this._foldersModal) {
            return;
        }
        this._foldersModal = this._modalService.openModal(UiFolderTreeModalComponent, this._folderTreeState, {
            allowBackdropClose: true,
            additionalClasses: ['ui-folder-tree-modal'],
            position: {
                right: '150px',
                top: '80px',
            },
            disableBackdrop: true,
        });
        this._foldersModal.afterClosed().subscribe(function () { return _this._foldersModal = undefined; });
    };
    return UiFolderPickerComponent;
}());
export { UiFolderPickerComponent };
